import { NgFor } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';

@Component({
  standalone: true,
  selector: 'dcc-dropdown',
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.scss'],
  imports: [FormsModule, NgFor],
})
export class DropdownComponent {
  @Input()
  pageSizes: number[];

  @Input()
  selectedSize: number;

  @Output()
  changedPageSize = new EventEmitter<number>();

  onChange(): void {
    this.changedPageSize.emit(this.selectedSize);
  }
}
